import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IHeaderAngularComp } from 'ag-grid-angular';
import { IHeaderParams } from 'ag-grid-community';

export interface ShippingConfigHeaderParams extends IHeaderParams {
  missingCount: () => number;
  onAutoCreate: () => void;
}

/**
 * Custom AG-Grid Header fuer die Versandkonfiguration-Spalte. Zweizeilig:
 * Spaltentitel oben, Button "Standard fuer fehlende ({n})" darunter — der
 * triggert das Auto-Create-Modal im Parent. Counter aktualisiert sich, wenn
 * der Parent gridApi.refreshHeader() ruft.
 */
@Component({
  standalone: true,
  imports: [CommonModule],
  selector: 'hawk-bulk-excel-shipping-config-header',
  template: `
    <div class="flex flex-col items-center justify-center gap-1 py-1 leading-tight w-full">
      <div class="font-semibold text-xs text-base-content">Versandkonfiguration</div>
      <button type="button"
              class="bm-btn bm-btn-xs"
              [class.bm-btn-warning]="missingCount() > 0"
              [class.bm-btn-ghost]="missingCount() === 0"
              [disabled]="missingCount() === 0"
              (click)="onClick($event)">
        Standard für fehlende ({{ missingCount() }}) erzeugen
      </button>
    </div>
  `,
})
export class ShippingConfigHeaderComponent implements IHeaderAngularComp {
  private params!: ShippingConfigHeaderParams;

  agInit(params: ShippingConfigHeaderParams): void {
    this.params = params;
  }

  refresh(params: ShippingConfigHeaderParams): boolean {
    this.params = params;
    return true;
  }

  protected missingCount(): number {
    return this.params?.missingCount?.() ?? 0;
  }

  protected onClick(event: MouseEvent): void {
    event.stopPropagation();
    this.params?.onAutoCreate?.();
  }
}
